(function () {
	'use strict';

	angular
		.module('app.setup')
		.service('sftpConfigService', sftpConfigService);

	sftpConfigService.$inject = ['$http'];

	function sftpConfigService($http) {
		var baseUrl = '/api/2/factndx/{0}/SFTPPublicKeys/';

		return {
			getSFTPKeyList: getSFTPKeyList,
			deleteSFTPKey: deleteSFTPKey,
			uploadSFTPKey: uploadSFTPKey
		};


		function getSFTPKeyList(siteId) {

			var url = String.format(baseUrl, siteId);
			return $http.get(url)
				.then(getSFTPKeyListSuccess, getSFTPKeyListError);

			function getSFTPKeyListSuccess(response) {
				// check for empty, set showAnchor based on that
				if (response.status === 204) {
					return response.status;
				}
				response.data.forEach(function (responseRow, index) {
					responseRow.dateImported = new Date(responseRow.dateImported).toLocaleString();
					responseRow.datePart = responseRow.dateImported.split(',')[0];
					responseRow.timePart = responseRow.dateImported.split(',')[1];
				}, response.data);
				return response.data;
			}
			function getSFTPKeyListError(error) {
				return error;
			}
		}

		function uploadSFTPKey(siteId, uploadSFTPKey) {
			var url = String.format(baseUrl, siteId);
			return $http.post(url, uploadSFTPKey)
				.then(uploadSFTPKeySuccess, uploadSFTPKeyError);

			function uploadSFTPKeySuccess(response) {
				return response;
			}
			function uploadSFTPKeyError(error) {
				if (error.status === 400) {
					return error.data.reason;
				}
				return 'Server error';
			}
		}

		function deleteSFTPKey(siteId, deleteKey) {
			var url = String.format(baseUrl, siteId);
			var configSFTPDelete = {};
			configSFTPDelete.data = {};
			configSFTPDelete.headers = {
				'Content-Type': 'application/json; charset=utf-8',
				'Accept': 'application/json'
			};
			configSFTPDelete.data.sshPublicKeyId = deleteKey.sshPublicKeyId;
			configSFTPDelete.data.sshPublicKeyBody = deleteKey.sshPublicKeyBody;
			return $http.delete(url, configSFTPDelete)
				.then(deleteSFTPKeySuccess, deleteSFTPKeyError);

			function deleteSFTPKeySuccess(response) {
				return 'Public Key deleted successfully';
			}
			function deleteSFTPKeyError(error) {
				return error;
			}
		}
	}
})();
